import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import {getItem} from '@/lib/local-storage'
import {hasPermission} from '@/lib/utils'
import store from '../store'
import {moduleRoutes} from '@/modules/core'

Vue.use(Meta)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: moduleRoutes()
})

router.beforeEach((to, from, next) => {
  let allowed = false
  const account = getItem('ACCOUNT')
  if (account) {
    store.commit('SET_ACCOUNT', account)
  }
  if (to.meta.auth === true) {
    allowed = true
  } else if (!account) {
    allowed = false
    const returnUrl = from.fullPath
    next({path: '/login', query: {returnUrl}})
  } else if (to.meta.auth === 'Idn') {
    allowed = true
  } else {
    allowed = to.meta.auth.some((i) => hasPermission(i))
  }

  if (allowed) {
    next()
  }
})

export default router
